import React, { useEffect, useState } from "react";
import { useAuth } from "../../../../hooks";
import { useLanguage } from "../../../../contexts/LanguageContext";
// import {
//   convertUnitsFinal,
//   energyCodes,
// } from "../../../../utils/dataAndFormulas/energyForms";
import { Column } from "@ant-design/plots";
import { formatWhole, formatPercentage } from "../../../../utils/numberFormat";
import "./SocialSummary.scss";

const SocialSummary = ({
  filters,
  site,
  baseline,
  valueBaseline,
  socialController,
  totales, // ✅ prop con datos por año/mes (totalesByFilters)
  totalesKPIs, // ✅ prop con KPIs calculados
  selectorSlot,
  exportSlot,
}) => {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;
  const [data, setData] = useState({
    produccionTotal: 0,
    produccionUnit: "",
    trabajadores: 0,
    horasTrabajadas: 0,
    horasExtrasRatio: 0,
    totalHorasExtras: 0,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        // console.log(
        //   "📊 Datos recibidos en SocialSummary:",
        //   { totales, totalesKPIs, filters, valueBaseline }
        // );

        // ✅ Usar totalesKPIs si está disponible, sino calcular desde totales
        const kpisData = totalesKPIs || totales;

        if (!kpisData || Object.keys(kpisData).length === 0) {
          console.warn("No hay datos de KPIs disponibles");
          return;
        }

        const year = filters.year;

        // 1. Producción total (VPS o VFS según baseline)
        const produccionTotal = valueBaseline?.[year] || 0;
        const produccionUnit = baseline?.[year] || ""; // VPS o VFS

        // 2. Trabajadores (KPIsoc1 = quantity_workers_kpis)
        const trabajadores = kpisData["quantity_workers_kpis"]?.[year]?.total || 0;

        // 3. Horas trabajadas (KPIsoc10 = total_hours_worked_extra_and_normal_kpis)
        const horasTrabajadas = kpisData["total_hours_worked_extra_and_normal_kpis"]?.[year]?.total || 0;

        // 4. Horas extras (KPIsoc8 + KPIsoc9)
        const horasExtras50 = kpisData["total_fifty_percent_overtime_kpis"]?.[year]?.total || 0;
        const horasExtras100 = kpisData["total_one_hundred_percent_overtime_kpis"]?.[year]?.total || 0;
        const totalHorasExtras = horasExtras50 + horasExtras100;

        // 5. Ratio Horas Extras / Horas Totales (KPIsoc10)
        const horasExtrasRatio = horasTrabajadas > 0 ? (totalHorasExtras / horasTrabajadas) * 100 : 0;

        // console.log("📊 Valores calculados:", {
        //   produccionTotal,
        //   produccionUnit,
        //   trabajadores,
        //   horasTrabajadas,
        //   totalHorasExtras,
        //   horasExtrasRatio
        // });

        setData({
          produccionTotal,
          produccionUnit,
          trabajadores,
          horasTrabajadas,
          horasExtrasRatio,
          totalHorasExtras,
        });

      } catch (error) {
        console.error("❌ Error al traer resumen social:", error);
      }
    };

    fetchData();
  }, [filters, site, baseline, valueBaseline, socialController, totales, totalesKPIs]);

  // --- Definición de tarjetas ---
  const resumenItems = [
    {
      title: t("total_production"),
      value: data.produccionTotal,
      unit: data.produccionUnit, // VPS o VFS según baseline
      rule: "whole",
      secondary: "",
      progress: null,
      //color: "yellow",
      hasProgress: false,
    },
    {
      title: t("workers"),
      value: data.trabajadores,
      unit: "", // Sin unidad
      rule: "whole",
     // secondary: "KPIsoc1",
      progress: null,
     // color: "yellow",
      hasProgress: false,
    },
    {
      title: t("hours_worked"),
      value: data.horasTrabajadas,
      unit: "", // Sin unidad
      rule: "whole",
      //secondary: "KPIsoc10",
      progress: null,
//  color: "yellow",
      hasProgress: false,
    },
    {
      title: t("overtime_ratio"),
      value: data.horasExtrasRatio,
      unit: `(${formatWhole(data.totalHorasExtras)}h)`,
      rule: "percentage",
      //secondary: "(KPIsoc8+KPIsoc9)/KPIsoc10",
      progress: data.horasExtrasRatio,
      color: "yellow",
      hasProgress: true,
    },
  ];

  // --- Renderizado ---
  return (
    <div className="resumen-grid">
      {resumenItems.map((item, index) => (
        <div
          key={index}
          className={`resumen-card-col${index === 0 ? " resumen-card-col--first" : ""}`}
        >
          <div className={`resumen-slot-row${index === resumenItems.length - 1 ? " resumen-slot-row--right" : ""}`}>
            {index === 0 && selectorSlot}
            {index === resumenItems.length - 1 && exportSlot}
          </div>
          <div
            className={`resumen-card social-card ${!item.hasProgress ? "no-progress" : ""}`}
          >
            <div className="card-meta">
              <div className="card-title-row">
                <span className="card-title">{item.title}</span>
              </div>
            </div>

            <div className="card-header">
              <span className="card-value">
                {item.rule === "percentage" ? formatPercentage(item.value) : formatWhole(item.value)}
                {item.unit && <span className="card-unit">{item.unit}</span>}
              </span>
              {item.secondary && (
                <div className="percentage-text">{item.secondary}</div>
              )}
            </div>

            {item.hasProgress && item.progress !== null && (
              <div className="progress-container">
                <div className="progress-bar">
                  <div
                    className="progress-fill"
                    style={{
                      width: `${Math.min(Math.round(item.progress || 0), 100)}%`,
                      backgroundColor: "#648EBC",
                    }}
                  />
                </div>
              </div>
            )}

            <div className="empty-space"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SocialSummary;
